import LayoutMaster from "components/layout/layout_master";
import { MaxButton, StatusMaxButton } from "components/view/button";
import HistoryUgameShow from "components/view/history_ugame_show";
import { AppReducerStateProps } from "lib/store";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import get_transaction_member_history_game_byMember_sm_point, {
  GetTransactionMemberHistorySMPointGameResponse,
} from "lib/worker/api/get_transaction_member_history_game_byMember_sm_point";
import Link from "next/link";
import { GetServerSideProps } from "next";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { useRouter } from "next/router";
import { prefix } from "lib/worker/client";

interface TransactionUdiamondProps {
  state: AppReducerStateProps;
  isLogin: boolean;
  infomation: CheckWithPrefixResponse;
}

function TransactionUdiamond(props: TransactionUdiamondProps) {
  const { transactionsHistoryuDiamond } = props.state.member;
  const router = useRouter();
  const [lineid, setlineid] = useState<string | null | undefined>(null);

  useEffect(() => {
    const infomations = CheckWithPrefix({ host: props.infomation.domain });
    setlineid(infomations.lineidchat);

    if (props.isLogin) {
      reload(true);
    }
  }, []);

  const reload = (re: boolean) => {
    get_transaction_member_history_game_byMember_sm_point({
      box: re ? [] : transactionsHistoryuDiamond,
      start: re ? 0 : transactionsHistoryuDiamond.length,
      limit: 100,
    });
  };

  const statusTitle = (
    StatusWinLost: string,
    IsSMPointAfterBet: boolean | undefined,
    value: GetTransactionMemberHistorySMPointGameResponse
  ): string | undefined => {
    if (!IsSMPointAfterBet) {
      if ((value.AfterBetAmount ?? 0) > 0) {
        return "กำไร";
      } else {
        return "ขาดทุน";
      }
    }
    switch (StatusWinLost ?? "") {
      case "Win":
        return "ได้รับ";
      case "Lost":
        return "ขาดทุน";
      default:
        return "เท่าทุน";
    }
  };

  return (
    <LayoutMaster
      content_setting={{
        title: "ประวัติกิจกรรม",
        description: "ประวัติกรรม ตรวจสอบ uDiamond ที่ได้รับ",
      }}
      information={props.infomation}
    >
      <div className="children-top-margin-top-10">
        <h1 className="text-center">ประวัติกิจกรรม</h1>
        <div className="container" style={{ paddingTop: 10 }}>
          <div className="card-add-bg">
            <div className="card-table">
              <div
                className="card-add-headings"
                style={{ paddingTop: 10, paddingBottom: 10 }}
              >
                <span className="card-add-heading text-left">วันที่</span>
                <span className="card-add-heading text-center">กิจกรรม</span>
                <span className="card-add-heading">เดิมพัน</span>
                <span className="card-add-heading">สถานะ</span>
                <span className="card-add-heading text-right">รางวัล</span>
              </div>
              <div className="line-span" style={{ marginTop: 0 }}></div>
              {(transactionsHistoryuDiamond ?? []).map(
                (value: GetTransactionMemberHistorySMPointGameResponse) => {
                  return (
                    <>
                      <HistoryUgameShow
                        Title={value.NameTH}
                        Amount={`${((value.Amount ?? 0) * -1).format(
                          2,
                          0
                        )} เพชร`}
                        StatusWinLost={statusTitle(
                          value.StatusWinLost ?? "",
                          value.IsSMPointAfterBet,
                          value
                        )}
                        AfterBetAmount={`${value.AfterBetAmount?.format(
                          2,
                          0
                        )} ${value.IsSMPointAfterBet ? `เพชร` : `เครดิต`}`}
                        DisplayCreatedAt={value.DisplayCreatedAt}
                        StatusWinLostColor={
                          (value.AfterBetAmount ?? 0) > 0 ? "green" : "red"
                        }
                        Status={`${
                          value.Uncalculated ? "สำเร็จ" : "กำลังดำเนินการ"
                        }`}
                      ></HistoryUgameShow>
                    </>
                  );
                }
              )}
            </div>
          </div>

          <MaxButton
            title="โหลดเพิ่ม"
            onClick={() => {
              reload(false);
            }}
            className="margin-top-10"
            status={StatusMaxButton.back}
          ></MaxButton>
        </div>
        <h2
          className="font-red margin-top-20 container"
          style={{ fontSize: 16 }}
        >
          *พบปัญหากรุณาติดต่อเจ้าหน้าที่ผ่านช่องทางแชท{" "}
          {router.pathname.includes("contact") == false && (
            <>
              {" "}
              {lineid != null ? (
                <Link href={lineid}>
                  <a>
                    <span>คลิก</span>
                  </a>
                </Link>
              ) : (
                <Link href={`/contact/${prefix}`}>
                  <a>
                    <span>คลิก</span>
                  </a>
                </Link>
              )}
            </>
          )}
        </h2>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(TransactionUdiamond);
